import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";

import Modal from "react-modal";
import moment from "moment";
import { toast } from "react-toastify";

const DpiForm = (props) => {
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "20%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "700px",
      maxHeight: "auto",
      height: "auto",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  function getCurrentTime() {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Format hours and minutes with leading zeros if necessary
    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }
  const [loading, setLoading] = useState(false);

  const currentDate = new Date().toISOString().slice(0, 10);
  const frmRef = useRef({});
  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);
  const [units, setUnits] = useState(false);

  const freshnessRef = useRef({});
  const [freshnessDetails, setFreshnessDetails] = useState([]);
  const [freshnessClose, setFreshnessClose] = useState(false);

  const checkListRef = useRef({});
  const [checkListDetails, setCheckListDetails] = useState([]);
  const [checkListClose, setCheckListClose] = useState(false);

  const { sendRequest: postDpi } = useHttp();
  const { sendRequest: getEmp } = useHttp();
  const { sendRequest: getunits } = useHttp();
  const [employeeId, setEmployeeId] = useState();

  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setEmployeeId(data.output);
      }
    );
  }, [getEmp]);

  useEffect(() => {
    getunits(
      {
        url: `/api/units?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          //  setUnits(res);
          //console.log(res);

          const filteredUnits =
            res && res.filter((item) => item.unitTypeName == "Weight");
          //console.log(filteredUnits);
          setUnits(filteredUnits);
        }
      }
    );
  }, [getunits]);

  const { sendRequest: getLot } = useHttp();

  const [lotId, setLotId] = useState();

  const handleStageChange = (e) => {
    //console.log(e.target.value);
    const stage = e.target.value;

    const data = {
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      stage: stage,
    };
    getLot(
      {
        url: "/api/getLotForPackQualityCheck/",
        method: "POST",
        body: data,
      },
      (data) => {
        //console.log(data);
        setLotId(data);
      }
    );
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (freshnessDetails === false) {
      toast.error("Freshness data required");
      return;
    }
    // if (productDetails.length === 0) {
    //   toast.error("Product Details required");
    //   return;
    // }
    if (checkListDetails && checkListDetails === "") {
      toast.error("Check List Details required");
      return;
    }

    setLoading(true);
    const data = {
      dpiDate: moment(frmRef.current.dpi_date.value).format("DD/MM/YYYY"),
      supervisorEmployeeId: frmRef.current.emp_id.value,
      inspectionTime: frmRef.current.inspection_time.value,
      stageofPackhouse: frmRef.current.stage.value,
      productDetails: productDetails,
      stockId: frmRef.current.lot_id.value,
      deficiencies: frmRef.current.deficiencies.value,
      freshness: freshnessDetails,
      temperature: frmRef.current.temp.value,
      checkList: checkListDetails,
      shelfLife: frmRef.current.shelf_life.value,
      remark: frmRef.current.remark.value,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      status: 1,
      createdDate: dateString,
      serviceId: props.sId,
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
    };
    //console.log(data);

    if (props.update) {
      data["dpiId"] = props.update.dpiId;
    }
    postDpi(
      {
        url: "/api/duringPackhouseInspection/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        props.addForm(false);

        toast.success(
          `During Packhouse Inspection Data ${
            props.update ? "Updated" : "Added"
          }`
        );
        setLoading(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    if (props.update) {
      //console.log(props.update);
      // frmRef.current.dpi_date.value = moment(props.update.dpiDate).format(
      //   "YYYY-MM-DD"
      // );
      frmRef.current.emp_id.value = props.update.SupervisorEmployeeId;
      frmRef.current.inspection_time.value = props.update.inspectionTime;
      frmRef.current.stage.value = props.update.stageofPackhouse;
      setProductDetails(props.update.productDetails);
      //frmRef.current.lot_id.value = props.update.lotId;
      frmRef.current.deficiencies.value = props.update.deficiencies;
      setFreshnessDetails(props.update.freshness);
      frmRef.current.temp.value = props.update.temperature;
      setCheckListDetails(props.update.CheckList);
      frmRef.current.shelf_life.value = props.update.shelfLife;
      frmRef.current.remark.value = props.update.remark;

      const event = new Event("change", { bubbles: true });
      frmRef.current.stage.dispatchEvent(event);
    }
  }, [props.update]);

  const submitFreshness = (e) => {
    e.preventDefault();
    const requiredFields = [
      "avg_unit_size",
      "unit",
      "shape",
      "colour",
      "flesh_firmness",
    ];
    const isAnyFieldEmpty = requiredFields.some(
      (field) => !freshnessRef.current[field].value
    );

    if (isAnyFieldEmpty) {
      toast.info("Fill all the fields");
      return;
    }

    setFreshnessDetails({
      avgUnitSize: freshnessRef.current.avg_unit_size.value,
      unit: freshnessRef.current.unit.value,
      shape: freshnessRef.current.shape.value,
      colour: freshnessRef.current.colour.value,
      fleshFirmness: freshnessRef.current.unit.value,
    });

    setFreshnessClose(false);
  };

  // useEffect(() => {
  //   if (freshnessClose && freshnessDetails) {
  //     freshnessRef.current.avg_unit_size.value =
  //       (freshnessDetails && freshnessDetails.avgUnitSize) || "";
  //     freshnessRef.current.unit.value =
  //       freshnessDetails && freshnessDetails.unit;
  //     freshnessRef.current.shape.value =
  //       freshnessDetails && freshnessDetails.shape;
  //     freshnessRef.current.colour.value =
  //       freshnessDetails && freshnessDetails.colour;
  //     freshnessRef.current.unit.value =
  //       freshnessDetails && freshnessDetails.fleshFirmness;
  //   }
  // }, [freshnessClose]);

  const submitCheckList = (e) => {
    e.preventDefault();
    setCheckListDetails([
      {
        contamination: checkListRef.current.contamination.value,
        standardPackagingMaterial: checkListRef.current.spm.value,
        properCushioning: checkListRef.current.proper_cushioning.value,
        durableMaterialUsed: checkListRef.current.dmu.value,
        sealedEffectivly: checkListRef.current.sealed_effectivly.value,
        detergentPrecise: checkListRef.current.detergent_precise.value,
        disposal: checkListRef.current.disposal.value,
        sortSize: checkListRef.current.sort_size.value,
        grading: checkListRef.current.grading.value,
        fungicidePercent: checkListRef.current.fungicide_percent.value,
        isSave: true,
      },
    ]);

    setCheckListClose(false);
    //console.log(checkListDetails);
  };

  useEffect(() => {
    //console.log(checkListDetails);
    if (checkListDetails) {
      //   checkListRef.current.contamination.value =
      //  checkListDetails &&checkListDetails.contamination;
      // checkListRef.current.spm.value =
      //   checkListDetails.standardPackagingMaterial;
      // checkListRef.current.proper_cushioning.value =
      //   checkListDetails.properCushioning;
      // checkListRef.current.dmu.value = checkListDetails.durableMaterialUsed;
      // checkListRef.current.sealed_effectivly.value =
      //   checkListDetails.sealedEffectivly;
      // checkListRef.current.detergent_precise.value =
      //   checkListDetails.detergentPrecise;
      // checkListRef.current.disposal.value = checkListDetails.disposal;
      // checkListRef.current.sort_size.value = checkListDetails.sortSize;
      // checkListRef.current.grading.value = checkListDetails.grading;
      // checkListRef.current.fungicide_percent.value =
      //   checkListDetails.fungicidePercent;
    }
  }, [checkListClose]);

  function handleShelfLifeInput(e) {
    const input = e.target;
    const value = input.value;

    // Remove non-digit characters
    const digitsOnly = value.replace(/\D/g, "");

    // Limit the input to three digits
    const truncatedValue = digitsOnly.slice(0, 3);

    // Update the input value
    input.value = truncatedValue;
  }

  const handleLotIdChange = (e) => {
    const id = e.target.value || 0;

    const filteredLot = lotId && lotId.filter((itm) => itm.stockId == id);
    console.log(filteredLot);
    setProductDetails(filteredLot);
  };

  return (
    <>
      {checkListClose && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">CheckList Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setCheckListClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-4">
              <label htmlFor={"unit"}>Contamination</label>
              <select
                id="contamination"
                className="form-control"
                ref={(el) => (checkListRef.current["contamination"] = el)}
              >
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>
            <div className="col-md-4">
              <label htmlFor={"spm"}>Standard Packaging Material</label>
              <select
                id="spm"
                className="form-control"
                ref={(el) => (checkListRef.current["spm"] = el)}
              >
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>
            <div className="col-md-4">
              <label htmlFor={"unit"}>Durable Material</label>
              <select
                id="dmu"
                className="form-control"
                ref={(el) => (checkListRef.current["dmu"] = el)}
              >
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>
          </div>

          <div className="row mb-2">
            <div className="col-md-4">
              <label htmlFor={"proper_cushioning"}>
                Proper Cushioning/Padding
              </label>
              <select
                id="proper_cushioning"
                className="form-control"
                ref={(el) => (checkListRef.current["proper_cushioning"] = el)}
              >
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>
            <div className="col-md-4">
              <label htmlFor={"sealed_effectivly"}>Sealed Effectivly</label>
              <select
                id="sealed_effectivly"
                className="form-control"
                ref={(el) => (checkListRef.current["sealed_effectivly"] = el)}
              >
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>
            <div className="col-md-4">
              <label htmlFor={"detergent_precise"}>
                Cleaning Detergent Precise
              </label>
              <select
                id="detergent_precise"
                className="form-control"
                ref={(el) => (checkListRef.current["detergent_precise"] = el)}
              >
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-4">
              <label htmlFor={"fungicide_percent"}>Fungicide Percent</label>
              <select
                id="fungicide_percent"
                className="form-control"
                ref={(el) => (checkListRef.current["fungicide_percent"] = el)}
              >
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>
            <div className="col-md-4">
              <label htmlFor={"sort_size"}>Sorting According to size</label>
              <select
                id="sort_size"
                className="form-control"
                ref={(el) => (checkListRef.current["sort_size"] = el)}
              >
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>
            <div className="col-md-4">
              <label htmlFor={"disposal"}>Disposal correctly</label>
              <select
                id="disposal"
                className="form-control"
                ref={(el) => (checkListRef.current["disposal"] = el)}
              >
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-4">
              <label htmlFor={"grading"}>Grading as per Standard</label>
              <select
                id="grading"
                className="form-control"
                ref={(el) => (checkListRef.current["grading"] = el)}
              >
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>
          </div>
          <div className="text-center mt-2">
            <button
              className="btn btn-sm btn-primary"
              onClick={submitCheckList}
            >
              Save
            </button>
          </div>
        </Modal>
      )}

      {freshnessClose && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Freshness Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setFreshnessClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div>
            <div className="row mb-2">
              <div className="col-md-3">
                <label htmlFor={"avg_unit_size"}>Average Unit Size</label>
                <input
                  type={"input"}
                  id={"avg_unit_size"}
                  required
                  ref={(el) => (freshnessRef.current["avg_unit_size"] = el)}
                  className="form-control"
                />
              </div>

              <div className="col-md-3">
                <label htmlFor={"unit"}>Unit</label>
                <select
                  id="unit"
                  className="form-control"
                  ref={(el) => (freshnessRef.current["unit"] = el)}
                >
                  <option>Select</option>
                  {units &&
                    units.map((x, i) => (
                      <option key={i} value={x.unitId}>
                        {x.unitAbbreviation}
                      </option>
                    ))}
                </select>
              </div>

              <div className="col-md-3">
                <label htmlFor={"shape"}>Shape</label>
                <select
                  id="shape"
                  className="form-control"
                  ref={(el) => (freshnessRef.current["shape"] = el)}
                >
                  <option value="Round">Round</option>
                  <option value="Conic">Conic</option>
                  <option value="Oblate">Oblate</option>
                  <option value="Oblong">Oblong</option>
                  <option value="Oblique">Oblique</option>
                  <option value="Ovate">Ovate</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-3">
                <label htmlFor={"colour"}>Colour</label>
                <input
                  type={"input"}
                  id={"colour"}
                  required
                  ref={(el) => (freshnessRef.current["colour"] = el)}
                  className="form-control"
                />
              </div>

              <div className="col-md-3">
                <label htmlFor={"flesh_firmness"}>Flesh Firmness</label>
                <select
                  id="flesh_firmness"
                  className="form-control"
                  ref={(el) => (freshnessRef.current["flesh_firmness"] = el)}
                >
                  <option value="Soft">Soft</option>
                  <option value="Moderate">Moderate</option>
                  <option value="Hard">Hard</option>
                </select>
              </div>
            </div>
            <div className="text-center mt-3">
              <button
                className="btn btn-sm btn-primary"
                onClick={submitFreshness}
              >
                Save
              </button>
            </div>
          </div>
        </Modal>
      )}

      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Product Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <table className="table table-sm table-bordered">
            <thead>
              <tr className="">
                <th>Item Id</th>
                <th>Item Description</th>
                <th>Item Type</th>
                <th>Item Category/Variety</th>
                <th>Item Quantity</th>
                <th>Unit</th>
              </tr>
            </thead>
            <tbody>
              {productDetails &&
                productDetails.map((itm, i) => {
                  return (
                    <tr key={i}>
                      <td>{itm.itemId}</td>
                      <td>{itm.productName}</td>
                      <td>{itm.productTypeName}</td>
                      <td>{itm.productSubTypeName}</td>
                      <td>{itm.productQuantityBal}</td>
                      <td>{itm.unitName}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          <hr />
          <div className="text-center  mt-2">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                setClose(false);
              }}
            >
              close
            </button>
          </div>
        </Modal>
      )}

      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">&nbsp;
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">
                    During Packhouse Inspection Form
                  </h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"dpi_date"}> {"DPI Date"}</label>
                      <input
                        type={"date"}
                        id={"dpi_date"}
                        required
                        ref={(el) => (frmRef.current["dpi_date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={
                          props.update
                            ? props.update.dpiDate
                                .split("/")
                                .reverse()
                                .join("-")
                            : selectedDate
                        }
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"emp_id"}>{"Assigned Supervisor"}</label>
                      <select
                        id="emp_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        required
                      >
                        <option selected disabled value="">
                          select
                        </option>
                        {employeeId &&
                          employeeId.map((x) => (
                            <option
                              value={x.empId}
                              selected={
                                props.update &&
                                props.update.supervisorEmployeeId == x.empId
                              }
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"inspection_time"}>
                        {" "}
                        {"Inspection Time "}
                      </label>
                      <input
                        type={"time"}
                        id={"inspection_time"}
                        required
                        ref={(el) => (frmRef.current["inspection_time"] = el)}
                        className="form-control"
                        defaultValue={getCurrentTime()}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"stage"}> {"Stage of Packhouse"}</label>
                      <select
                        id="stage"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["stage"] = el)}
                        onChange={handleStageChange}
                        required
                      >
                        <option value="select">Select</option>
                        <option value="Lot Creation">Lot Creation</option>
                        <option value="Cleaning">Cleaning & Washing</option>
                        <option value="Sorting">Sorting /Grading</option>
                        <option value="Packaging">
                          Packaging & Labeling /Marking
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"lot_id"}> {"Lot id "}</label>
                      <select
                        id="lot_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["lot_id"] = el)}
                        required
                        onChange={handleLotIdChange}
                      >
                        <option value="">select</option>
                        {lotId &&
                          lotId.map((x) => (
                            <option
                              value={x.stockId}
                              selected={props.update.stockId == x.stockId}
                            >
                              {x.lotNo + "(" + x.productName + ")"}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"product_details"}
                        autoComplete="off"
                        onClick={() => {
                          setClose(true);
                        }}
                        ref={(el) => (frmRef.current["product_details"] = el)}
                        className="btn btn-sm btn-success"
                      >
                        Add
                      </button>
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"deficiencies"}> {"Deficiencies"}</label>
                      <select
                        id="deficiencies"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["deficiencies"] = el)}
                      >
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"freshness"}> {"Freshness"}</label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"freshness"}
                        ref={(el) => (frmRef.current["freshness"] = el)}
                        className="btn btn-sm btn-warning"
                        onClick={() => {
                          setFreshnessClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"temp"}> {"Temperature (°C) "}</label>
                      <input
                        type={"number"}
                        id={"temp"}
                        required
                        ref={(el) => (frmRef.current["temp"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"check_list"}>{"Check List"}</label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"check_list"}
                        ref={(el) => (frmRef.current["check_list"] = el)}
                        className="btn btn-sm btn-warning"
                        onClick={() => {
                          setCheckListClose(true);
                        }}
                      >
                        Check
                      </button>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"shelf_life"}>
                        {" "}
                        {"Shelf Life (days) "}
                      </label>
                      <input
                        type={"number"}
                        id={"shelf_life"}
                        required
                        ref={(el) => (frmRef.current["shelf_life"] = el)}
                        onInput={handleShelfLifeInput}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className=" text-right">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default DpiForm;
